/* istanbul ignore file */
import { onTeamSelection } from 'common/services/teams.service';
import AppRouter from 'common/AppRouter';
import PulseIterationPicker from 'views/root/views/home/views/pulse/components/PulseIterationPicker';

export const ADDITIONAL_TOP_BAR_COMPONENT_MAP = {
  PulseIterationPicker
};

const pathConfig = {
  '/pulse': {
    iterationsPickerTooltip:
      'Pulse is currently available for the latest iteration only'
  }
};
// TO DO: need to chage all places that use this
export const allTeams = /** @type {const} */ ({
  id: -1,
  name: 'All Teams',
  initials: 'ALL'
});

export const METRICS_PAGE_PATHS = [
  AppRouter.PERFORMANCE.path,
  AppRouter.TEAM_GOALS.path
];

export const resolveIterationsPickerTooltipByPath = path =>
  pathConfig[path] ? pathConfig[path].iterationsPickerTooltip : null;

export const handleTeamChange = ({
  team,
  selectTeamId,
  history,
  isTeamLicense
}) =>
  onTeamSelection({
    team,
    reduxActionFn: selectTeamId,
    history,
    isTeamLicense
  });
